// extracted by mini-css-extract-plugin
export default {"wrap":"dG-z","fullWidth":"eG-z","hideOnDesktop":"fG-z","content":"gG-z","hasOpenedNav":"hG-z","crumbsList":"iG-z","dropdownsWrap":"jG-z"};